jQuery_T4NT(document).ready(function ($) {
    /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
    $(document).on('variant:changed', function (evt) {
        // console.log( evt.currentVariant );
        // $('[data-variant-toggle]').hide(0);
        // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
    });

    window._klOnsite = window._klOnsite || [];

    const app = {
      globals: {
          currentCartUrl: null
      },
        init: () => {
            app.visitForm();
            app.readmore();
            app.collectionPanes();
            app.viewProductInStore.init();
            app.configurator.init();
            app.faq.init();
            app.sidemenu.init();
            app.scrollTo();
            app.futy.init();
            app.cookieFirst();
            app.goBack();
            app.saveCart();
            app.fixSearchRouteLight();
          app.klavyoEvents();
          app.openCart();
        },
        openCart: () => {
          const searchParams = new URLSearchParams(window.location.search);
          const query = searchParams.get("k20cart");
          if (!query) return;
          if(query != 'open') return;

          setTimeout(() => {
            $('.t4s-site-nav__cart > a').trigger('click')
          }, 500)
        },
        fixSearchRouteLight: () => {
              $('form[action="/search"] .t4s-mini-search__cat').remove()
            $('form[action="/search"] [name="resources[options][fields]"]').remove()
          
            $('body').on('click', 'a[href="/search"]', function(e){
              $('form[action="/search"] .t4s-mini-search__cat').remove()
              $('form[action="/search"] [name="resources[options][fields]"]').remove()
            })
        },
        fixSearchRoute: () => {

            $('form[action="/search"] .t4s-mini-search__cat').remove()
            $('form[action="/search"] [name="resources[options][fields]"]').remove()
            $('form[action="/search"]').attr('action', '/collections/zoeken')
          
            $('body').on('click', 'a[href="/search"]', function(e){
              e.preventDefault();
              
              $('form[action="/search"] .t4s-mini-search__cat').remove()
              $('form[action="/search"] [name="resources[options][fields]"]').remove()
              $('form[action="/search"]').attr('action', '/collections/zoeken')
            })

          
            

          if($('body').hasClass('template-collection_zoeken')){

              
            
              const searchParams = new URLSearchParams(window.location.search);
              const query = searchParams.get("q");
              if (!query) return;
            
              const page = searchParams.get("page");
              if(page && Number(page) > 1) {
                window.location.href = window.location.href.replace(`page=${page}`,`page=1`)
                return;
              }
              const queryLower = query.toLowerCase();
            
              // Filter a single node
              function filterProductNode(node) {
                const titleEl = node.querySelector(".t4s-product-title");
                if (!titleEl) return;
            
                const titleText = titleEl.textContent.trim().toLowerCase();
                if (!titleText.includes(queryLower)) {
                  node.remove();
                }
              }
            
              // Initial scan (if already loaded)
              document.querySelectorAll(".k20-col-product").forEach(filterProductNode);
            
              // Observer for dynamic loading
              const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                  mutation.addedNodes.forEach((node) => {
                    if (
                      node.nodeType === 1 &&
                      node.classList.contains("k20-col-product")
                    ) {
                      filterProductNode(node);
                    } else if (node.nodeType === 1) {
                      // If wrapper added, scan children
                      node.querySelectorAll?.(".k20-col-product").forEach(filterProductNode);
                    }
                  });
                });
              });
            
              observer.observe(document.body, {
                childList: true,
                subtree: true,
              });
            
          }
        },
        futy: {
            init: () => {
                if($('body').hasClass('template-page_mimeeq-configurator')) return;
              
                app.futy.load();
                app.futy.listen();
            },
            load: () => {
                window.Futy = { key: '67583f818d3a3' };
                (function (e, t) {
                    var n = e.createElement(t);
                    n.async = true;
                    var f = window.Promise && window.fetch ? 'modern.js' : 'legacy.js';
                    n.src = 'https://v1.widget.futy.io/js/futy-widget-' + f;
                    var r = e.getElementsByTagName(t)[0];
                    r.parentNode.insertBefore(n, r);
                })(document, 'script');
            },
            listen: () => {
                const excludePagePaths = ['/contact', '/winkelafspraak', '/wonen-inspiratieboek', '/winkelvoorwaarden', '/interieuradvies', '/andere-vragen', '/cart', '/loov'];
                const currentPath = window.location.pathname;

                // Helper: check of widget recent gesloten is (binnen 15 dagen)
                function isFutyRecentlyClosed() {
                    const data = JSON.parse(localStorage.getItem('futyClosedInfo'));
                    if (!data || !data.timestamp) return false;

                    const now = new Date().getTime();
                    // const fifteenDays = 10 * 1000;
                    const fifteenDays = 15 * 24 * 60 * 60 * 1000;

                    return now - data.timestamp < fifteenDays;
                }

                // Stoppen als pagina is uitgesloten of widget recent gesloten
                if (excludePagePaths.find((a) => currentPath.includes(a))) return;
                if (isFutyRecentlyClosed()) return;

                let hasScrolled = false;
                let timerStarted = false;

                // Open widget na scroll + 5 seconden
                $(window).on('scroll', function () {
                    if ($(window).scrollTop() > 450 && !hasScrolled) {
                        hasScrolled = true;

                        if (!timerStarted) {
                            timerStarted = true;

                            console.log('futy timer started');

                            setTimeout(function () {
                                if (window.Futy?.widgetVisible === false) {
                                    // console.log('futy ⏱️ Openen na scroll + vertraging');
                                    window.Futy.EventBus.$emit('widget-open');
                                }
                            }, 5000);
                        }
                    }
                });

                function futyToggled() {
                    // console.log('bij een toggle zetten we altijd futy');
                    localStorage.setItem(
                        'futyClosedInfo',
                        JSON.stringify({
                            timestamp: new Date().getTime(),
                        })
                    );
                }

                // Gebruik 'widget-toggle' om sluiting te detecteren
                const waitForEventBus = setInterval(() => {
                    if (window.Futy && window.Futy.EventBus && typeof window.Futy.EventBus.$on === 'function') {
                        clearInterval(waitForEventBus);

                        window.Futy.EventBus.$on('widget-toggle', () => {
                            futyToggled();
                        });
                        window.Futy.EventBus.$on('widget-open', () => {
                            futyToggled();
                        });
                        window.Futy.EventBus.$on('widget-closed', () => {
                            futyToggled();
                        });
                    }
                }, 250);
            },
        },
        scrollTo: () => {
            $('body').on('click', 'a[href^="#scroll_to_"]', function (e) {
                e.preventDefault();
                let id = $(this).attr('href');
                let cleaned = id.replace('scroll_to_', '');
                if ($(`${id}`).length > 0) {
                    $('html, body').animate(
                        {
                            scrollTop: $($(this).attr('href')).offset().top - 250,
                        },
                        700
                    );
                    return;
                }
                if ($(`${cleaned}`).length > 0) {
                    $('html, body').animate(
                        {
                            scrollTop: $($(this).attr('href')).offset().top - 250,
                        },
                        700
                    );
                    return;
                }
            });
        },
        sidemenu: {
            init: () => {
                app.sidemenu.listen();
            },
            listen: () => {
                $('a[href~="#open_sidemenu"]').on('click', function () {
                    jQuery_T4NT('[data-menu-drawer]').trigger('click');
                });
              
                $('a[href~="#open_collection_filters"]').on('click', function () {
                    jQuery_T4NT('.t4s-btn-sidebar').trigger('click')
                });
              
            },
        },
        faq: {
            init: () => {
                if ($('.jn-faq-page').length == 0) return;
                app.faq.render();
                app.faq.listen();
            },
            render: () => {
                let urlGroups = {};

                $('.jn-faq-page-menu a').each(function (index, $a) {
                    if (!$($a).attr('href') || $($a).attr('href').startsWith('#')) return;

                    let urlGroup = 'none';

                    if ($($a).attr('data-group')) urlGroup = $($a).attr('data-group');

                    if (!urlGroups[urlGroup])
                        urlGroups[urlGroup] = {
                            name: urlGroup,
                            urls: [],
                        };

                    let active = false;

                    let url = $($a).attr('href');

                    if (window.location.pathname.endsWith(url)) {
                        active = true;
                        $($a).addClass('active');
                    }

                    urlGroups[urlGroup].urls.push({
                        name: $($a).text(),
                        url: url,
                        active: active,
                    });

                    console.log($($a));
                });

                $('.jn-faq-page').prepend(`
            <div class="faq-select-navigation">
              <label>Kies een vraag</label>
              <select class="faq-select-navigation-select">
                  ${Object.entries(urlGroups)
                      .map((entry) => {
                          const [key, value] = entry;
                          return `
                      <optgroup label="${key}">
                        ${value.urls
                            .map((item) => {
                                return `
                            <option ${item.active ? 'selected' : ''} value="${item.url}">${item.name}</option>
                          `;
                            })
                            .join('')}
                      </optgroup>
                    `;
                      })
                      .join('')}
              </select>
            </div>
          `);
            },
            listen: () => {
                $('.faq-select-navigation-select').on('change', function (e) {
                    e.preventDefault();
                    window.location.href = `${$(this).val()}#faq_section`;
                });
            },
        },
        showLoading: (options) => {
            let html = `<h2>Dromen waarmaken...</h2>`;

            if (options && options.html) html = options.html;

            Swal.fire({
                html: html,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
        },
        configurator: {
            init: () => {
                app.configurator.listen();
            },
            listen: () => {
                $('body').on('click', 'a[href*="#open_configuration"]', function (e) {
                    e.preventDefault();

                    if ($('.mask-overlay').length > 0) $('.mask-overlay').trigger('click');

                    app.configurator.productPresetsModal();
                });

                $('.mmq-button').on('click', function (e) {
                    e.preventDefault();
                });

              // make sure this buttons are only showed when buttons are present
              if($('.mmq-button').length == 0) $('a[href*="#trigger_product_configurator"],.trigger-product-configurator').hide()

              // trigger mimeeq if buttons are triggered
              $('a[href*="#trigger_product_configurator"],.trigger-product-configurator').on('click', function(e){
                e.preventDefault();
                $('.mmq-button')[0].click();
              })

                $('body').on('click', '.k20-swal-configuration-options > a', function (e) {
                    e.preventDefault();
                    if ($('.mmq-button').length > 0) {
                        let openConfigurator = false;

                        if ($(this).attr('href').includes('tuin') && window.location.href.includes('tuin')) openConfigurator = true;
                        if ($(this).attr('href').includes('eettafel') && window.location.href.includes('eettafel')) openConfigurator = true;
                        if ($(this).attr('href').includes('salon') && window.location.href.includes('salon')) openConfigurator = true;
                        if ($(this).attr('href').includes('bank') && window.location.href.includes('bank')) openConfigurator = true;
                        if ($(this).attr('href').includes('tv') && window.location.href.includes('tv')) openConfigurator = true;

                        if (openConfigurator) {
                            e.preventDefault();
                            $('.mmq-button')[0].click();
                            Swal.close();
                            return;
                        }
                    }

                    app.showLoading();
                    window.location.href = $(this).attr('href');
                });
            },
            productPresetsModal: () => {
                dataLayer.push({
                    event: 'configurator_product_presets_modal',
                });

                Swal.fire({
                    customClass: `k20-swal-configuration-options-swal`,
                    html: `
                      <div class="k20-swal-configuration-options-container">
                        <h2>Jouw droommeubel start hier...</h2>
                        <p>Kom naar een van onze showrooms echt te voelen en ontdekken hoe onze vakmensen jouw product tot leven brengen.</p>
                        <div class="k20-swal-configuration-options">
                          <!--<a href="https://kas20.nl/pages/configureer-eettafel" style="background-image:url('https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Massief4cmNaturelDeensFreya_4_1080x_3a4cc799-24d4-4536-8431-64fc9fc96fca.webp?v=1741343249');">Eettafel</a>-->
                          <a href="https://kas20.nl/products/melamine-eettafel-travertino-plat-ovaal-columbus-duo-walnut-brown-2x?variantCode=EETTAFEL%3DMateriaal-a8%26Bladvorm-a6%26Randafwerking-a18%26Randkleur-a7%26Bladdikte-a3%26Lengte-a1%26Breedte-a1%26RondAfmeting-%26Hoogte-a2%26Onderstellen-a27%26Kleuronderstel-%26HiddenOptionSKUcodeforthinckness-a1%26Melding-%26HiddenOptionSKUcodeforEDGE-a2%26Kleuronderstelhout-%26MeldingFenixRand-%26MeldingFenixRand1-%26SelecteerMateriaal-%26Kleuronderstelhout1-a5%26MateriaalOnderstel-a2%26Kleuronderstelbeton-%26Kiesmateriaal-a8%26KiesKleur-i12%26EikenFineer-%26Keramiek-%26Patronen-%26MeldingKERAMIEK25mm-%26MeldingKERAMIEK25mm1-" style="background-image:url('https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Massief4cmNaturelDeensFreya_4_1080x_3a4cc799-24d4-4536-8431-64fc9fc96fca.webp?v=1741343249');">Eettafel</a>
                          <a href="https://kas20.nl/collections/tuintafels-1/products/keramiek-tuintafel-cuarzo-reno-deens-ovaal-matrix-dun-beige?variantCode=TUINTAFEL%3DTuintafel-a1%26Materiaal-a7%26Tafelkleuren-p27%26Bladvorm-a4%26Bladdikte-b15%26Lengte-a1%26Breedte-a1%26RondAfmeting-%26Hoogte-a2%26Onderstellen-b2%26Kleuronderstel-c9%26HiddenOptionSKUcodeforthinckness-a1%26Melding-%26SPECIAL-a1%26Meldingonderstel-%26Meldingkleuronderstel-" style="background-image:url('https://kas20.nl/cdn/shop/files/KEM1014080DOR097MDBH76-4.jpg?v=1745912812');">Tuintafel</a>
                          <!--<a href="https://kas20.nl/pages/banken-overzicht" style="background-image:url('https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Screenshot_2023-12-22_at_18.03.52.png?v=1703264666');">Bank</a>-->
                          <a href="https://kas20.nl/pages/configureer-bank" style="background-image:url('https://cdn.shopify.com/s/files/1/0269/4840/3234/files/1_1080x_015a3468-8a01-41f9-b87f-f9c1e58378aa.webp?v=1741343249');">Bank</a>
                          <a href="https://kas20.nl/collections/salontafels-1/products/keramiek-eiken-duo-salontafel-rond-maan-onderstel?variantCode=SALONTAFEL%3DAantalsalontafels-a2%26Materiaal-%26Tafelkleuren-%26Bladvorm-%26Randafwerking-%26Randkleur-%26Bladdikte-%26Lengte-%26Breedte-%26RondAfmeting11-%26Hoogte-%26Onderstellen-b25%26Kleuronderstel-%26HiddenOptionSKUcodeforthinckness-a1%26Melding-%26HiddenOptionSKUcodeforthinckness1-a1%26Tafelkleuren1-o6%26Bladvorm1-a11%26RondAfmeting-a3%26Randafwerking1-b15%26Randkleur1-a7%26Bladdikte1-b16%26Tafelkleuren11-b5%26Bladvorm11-a1%26RondAfmeting1-a1%26Randafwerking11-b9%26Randkleur11-a5%26Bladdikte11-b9%26FenixRandkleurWaarschuwing-%26FenixRandkleurWaarschuwing1-%26FenixRandkleurWaarschuwing11-%26KleuronderstelMassief1-b5%26SalonExtra-a2" style="background-image:url('https://cdn.shopify.com/s/files/1/0269/4840/3234/files/20-113_1080x_ee82c0ea-5c73-46a2-a286-441e80852b3f.webp?v=1741343249');">Salontafel</a>
                          <!--<a href="https://kas20.nl/pages/configureer-bank" style="background-image:url('https://cdn.shopify.com/s/files/1/0269/4840/3234/files/067904b5-60e3-4ca8-8d03-c34ac94c7bcc_x425_eecb3c1c-e995-444b-807d-be56a3263796.png?v=1717752702');">Bank</a>-->
                        </div>
                      </div>
                    `,
                    background: 'transparent',
                    showCancelButton: true,
                    showConfirmButton: false,
                    width: 700,
                    confirmButtonColor: '#000',
                    cancelButtonText: 'Sluiten',
                });
            },
        },
        viewProductInStore: {
            init: () => {
                app.viewProductInStore.listen();
                app.viewProductInStore.printTimesHtml();
                app.viewProductInStore.renderStoresPages();
            },
            renderStoresPages: () => {
                $('.render-showrooms-page').each(function(index, $el){
                  $($el).html(app.viewProductInStore.renderStoresPage({stores:jnApp.vars.jnStores}))
                })
            },
            getTimesHtml: (storeId, type) => {
                return `
                    ${jnApp.vars.jnStores
                        .find((store) => store.id == storeId)
                        .times.map((time) => {
                            let canAdd = !time.types || (time.types && time.types.includes(type));
                            if (!canAdd) return '';

                            if (time.paragraph) return `<p>${time.paragraph}</p>`;
                            if (time.html) return `${time.html}`;
                            if (time.spacer) return `<div class="spacer my-1"></div>`;

                            let sublabel = time.sublabel ? `<span class="sublabel">${time.sublabel}</span>` : '';

                            let bold = false;
                            if (time.bold) bold = true;

                            return `<p><span class="${time.bold ? 'bold' : ''}">${time.label || ''}</span> ${time.time || ''}${sublabel}</p>`;
                        })
                        .join('')}
                `;
            },
            printTimesHtml: () => {
                $('div.print-jn-store').each(function (index, $el) {
                    let storeId = $($el).attr('data-store-id');
                    $($el).html(app.viewProductInStore.getTimesHtml(storeId, 'footer'));
                });

                $('a[href^="#opentimes"]').each(function (index, $el) {
                    // #opentimes_enschede-01
                    let href = $(this).attr('href');
                    let storeId = href.split('_')[1];
                    $($el).after(`
                        <div class="opentimes-anchor-placement">
                            <p><strong>Openingstijden</strong></p>
                            ${app.viewProductInStore.getTimesHtml(storeId, 'detail')}
                        </div>
                    `);
                    $($el).hide();
                    // $($el).html(app.viewProductInStore.getTimesHtml(storeId));
                });
            },
            renderStoresPage: ({stores}) => {
              return `
                    <div class="k20-stores-container">
                      ${stores
                          .map((store) => {
                              return `
                                <div class="k20-store">
                                <div class="k20-store-image" style="background-image:url('${store.store_img}');"></div>
                                <div class="k20-store-content">
                                    <h2>${store.name}</h2>
                                    <div>${store.description}</div>
                                    <div class="k20-store-columns">
                                    <div>
                                        <h5 class="color-red">Openingstijden</h5>
                                        <p>${app.viewProductInStore.getTimesHtml(store.id, 'detail')}</p>
                                    </div>
                                    <div>
                                        <h5 class="color-red">Adres</h5>
                                        <p>${store.address}</p>
                                        <div class="mt-8 mb-4">
                                          <a class="t4s-btn k20-btn-sm btn-block" href="${store.store_url}">${store.store_url_label}</a>
                                        </div>
                                        ${store.route_url ? `
                                        <div>
                                          <a class="t4s-btn k20-btn-sm k20-btn-red btn-block" href="${store.route_url}">Open Route</a>
                                        </div>
                                        ` : ``}
                                    </div>
                                    </div>
                                </div>
                                </div>
                            `;
                          })
                          .join('')}
                    </div>
                  `
            },
            listen: () => {
                $('body').on('click', '.k20-pdp-stores-btn,.k20-pdp-stores-btn-trigger', function (e) {
                  e.preventDefault();
                    let storeIds = $(this).attr('data-stores');
                    if (storeIds) {
                        storeIds = storeIds.split(',');
                        storeIds.push('maak-een-afspraak');
                    } else {
                        storeIds = ['de-kwakel-01', 'helmond-01', 'almere-01', 'enschede-01', 'maak-een-afspraak'];
                    }

                    let filterStores = jnApp.vars.jnStores;

                    if (storeIds && storeIds.length > 0) filterStores = jnApp.vars.jnStores.filter((a) => storeIds.includes(a.id) || storeIds.includes(a.label));

                    e.preventDefault();
                    Swal.fire({
                        width: 700,
                        confirmButtonColor: 'var(--primary)',
                        showCancelButton: true,
                        cancelButtonText: 'Sluiten',
                        html: app.viewProductInStore.renderStoresPage({stores:filterStores}),
                        reverseButtons: true,
                        confirmButtonText: 'Bekijk alle',
                    }).then((result) => {
                        if (result.isConfirmed) window.location.href = '/pages/showroom-bezoeken';
                    });
                });
            },
        },
        collectionPanes: () => {
            let currentIndex = 0;
            jQuery_T4NT('.t4s-products > div').each(function (index, $el) {
                if (!jnApp.vars.collectionPanes[currentIndex]) return;
                if (index % 3 != 0) return;

                $(`
						<div class="kas-collection-banner t4s-product t4s-pr-grid t4s-col-item" style="background-image:url('${jnApp.vars.collectionPanes[currentIndex].background_image}');">
							${jnApp.vars.collectionPanes[currentIndex].content ? `<div class="jn-collection-content pattern-dark">${jnApp.vars.collectionPanes[currentIndex].content}</div>` : ``}
							${jnApp.vars.collectionPanes[currentIndex].raw_content ? `<div class="jn-collection-raw_content">${jnApp.vars.collectionPanes[currentIndex].raw_content}</div>` : ``}
						</div>
					`).insertAfter($el);

                currentIndex = currentIndex + 1;
            });
        },
        visitForm: () => {
            if (window.location.href.includes('winkelafspraak')) return;
            if (window.location.href.includes('showroom-bezoeken-') && $('.globo-formbuilder').length > 0) {
              // globo-formbuilder
              $('body').on('click', 'a[href="/pages/winkelafspraak"]', function(e){
                e.preventDefault();
                $('html, body').animate(
                        {
                            scrollTop: $('.globo-formbuilder').offset().top - 100,
                        },
                        700
                    );
              })
              return;
            };

            $('body').on('click', 'a[href*="/pages/winkelafspraak"]', function (e) {
                e.preventDefault();
                $('.jn-btn-trigger-winkelafspraak').trigger('click');
            });
        },
        readmore: () => {
            const charLimit = 150;

            $('.auto-readmore').each(function () {
                const $original = $(this);
                const fullHtml = $original.html();
                const temp = $('<div>').html(fullHtml);

                let charCount = 0;
                let cutoffReached = false;

                function getCroppedHtml(node) {
                    if (cutoffReached) return '';

                    if (node.nodeType === 3) {
                        const text = node.nodeValue;
                        if (charCount + text.length <= charLimit) {
                            charCount += text.length;
                            return text;
                        } else {
                            const visibleText = text.slice(0, charLimit - charCount);
                            cutoffReached = true;
                            return visibleText + '...';
                        }
                    } else if (node.nodeType === 1) {
                        const tagName = node.nodeName.toLowerCase();
                        const attrs = Array.from(node.attributes)
                            .map((attr) => `${attr.name}="${attr.value}"`)
                            .join(' ');
                        const open = `<${tagName}${attrs ? ' ' + attrs : ''}>`;
                        const close = `</${tagName}>`;

                        let inner = '';
                        for (let i = 0; i < node.childNodes.length; i++) {
                            inner += getCroppedHtml(node.childNodes[i]);
                            if (cutoffReached) break;
                        }

                        return open + inner + close;
                    }

                    return '';
                }

                const croppedHtml = getCroppedHtml(temp[0]);

                const shortHtml = `
			  <div class="readmore-short">
				${croppedHtml}<span class="readmore-dots"> </span>
				<a href="#" class="readmore-toggle">Lees meer</a>
			  </div>
			`;

                const fullHtmlWrapped = `
			  <div class="readmore-full" style="display:none;">
				${fullHtml}
				<a href="#" class="readmore-toggle">Lees minder</a>
			  </div>
			`;

                $original.html(shortHtml + fullHtmlWrapped);
            });

            // Toggle between short and full
            $(document).on('click', '.readmore-toggle', function (e) {
                e.preventDefault();
                const $container = $(this).closest('.auto-readmore');
                $container.find('.readmore-short, .readmore-full').toggle();
            });
        },
      cookieFirst: () => {
        
        $('body').on('click', '.cookiefirst-root', function (event) {
            if (event.target === event.currentTarget) {
                // event.currentTarget.close()
                $('.cookiefirst-root [data-cookiefirst-action="accept"]').trigger('click');
            }
            // $('.cookiefirst-root [data-cookiefirst-action="accept"]').trigger('click');
        });
    
        $('body').on('click', '.open-cookie-settings', function (e) {
            e.preventDefault();
            CookieFirst.openPanel();
        });
      },
      goBack: () => {
			$('.goback').on('click', function(e){
			  e.preventDefault()
			  if (document && document.referrer && typeof document.referrer === 'string' && document.referrer.includes('kas20.nl')) {
				// history.back();
				window.location.href = document.referrer
			  } else {
				window.location.href = "https://kas20.nl";
			
			  }
			})
		},
      saveCart: () => {
        
    
      // Function to generate the Shopify cart URL
      async function generateShopifyCartUrl() {
        const shopDomain = window.location.origin;
    
        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();
    
          const cartItems = cart.items.map(item => `${item.variant_id}:${item.quantity}`).join(',');
          const cartUrl = `${shopDomain}/cart/${cartItems}`;
          return cartUrl;
        } catch (error) {
          console.error('Error generating cart URL:', error);
          return null;
        }
      }
    
      function simulateUserTyping(input, value) {
      input.focus(); // focus first if needed
      input.value = value;
    
      // Trigger the same events that a real user would
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true }));
    }
    
      // Function to observe the DOM after the popup opens
      function waitForKlaviyoInputAndSetCartUrl() {
        const inputSelector = 'input[id^="cart_url_"]';
    
        const observer = new MutationObserver((mutations, obs) => {
          const input = document.querySelector(inputSelector);
          
          if (input) {
            generateShopifyCartUrl().then(cartUrl => {
              console.log({input, cartUrl})
              if (cartUrl) {
                app.globals.currentCartUrl = cartUrl;
                setTimeout(() => {
                  // input.value = cartUrl;  
                  simulateUserTyping(input, cartUrl);
                console.log('✅ Cart URL set in Klaviyo popup:', cartUrl);
                },250);
                
              }
            });
    
            obs.disconnect(); // Stop once input is found and set
          }
        });
    
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    
      // Open the Klaviyo form after 3 seconds, then observe for the input
      // setTimeout(function () {
      //   window._klOnsite.push(['openForm', 'R9csUu']);
      //   waitForKlaviyoInputAndSetCartUrl(); // start observing AFTER opening
      // }, 3000);

        $('body').on('click', '.k20-btn-savecart', function(e){
          e.preventDefault();

          window._klOnsite.push(['openForm', 'R9csUu']);
          waitForKlaviyoInputAndSetCartUrl();
        })
      },
      klavyoEvents: () => {
        window.addEventListener("klaviyoForms", function(e) {
          console.log('catch-all',e)
            if (e.detail.type == 'submit') {

              console.log('catch-submit',e)

              let formName = 'Onbekend formulier';

              if(e.detail.formId == "R9csUu"){

                formName = 'Email winkelmand';
                
                setTimeout(() => {
                  console.log(`klavyo cart event tracked`, e)
                  let klEvent = ["track", "Cart Saved Event", {
                      'cart url': app.globals.currentCartUrl,
                      form_name: "popup-form",
                      timestamp: new Date().toISOString()
                    }]
        
            
                    window._klOnsite.push(klEvent);
                  
                  
                },500);
              }

              if(e.detail.formId == "WYjjKG"){
                formName = 'Nieuwsbrief';
              }

              


              gtag('event', 'klavyo_form_submit', {
                event_category: 'Klaviyo form',
                event_label: formName,
                form_id: e.detail.formId
              });

              

            }
        });
      }
    };

    app.init();
});
